import { render, staticRenderFns } from "./multieconsent.vue?vue&type=template&id=4c021c08&scoped=true&"
import script from "./multieconsent.vue?vue&type=script&lang=js&"
export * from "./multieconsent.vue?vue&type=script&lang=js&"
import style0 from "./multieconsent.vue?vue&type=style&index=0&id=4c021c08&scoped=true&lang=scss&"
import style1 from "../../../public/static/fonts.scss?vue&type=style&index=1&id=4c021c08&scoped=true&lang=scss&"
import style2 from "./multieconsent.vue?vue&type=style&index=2&id=4c021c08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c021c08",
  null
  
)

component.options.__file = "multieconsent.vue"
export default component.exports